import {Model} from "@vuex-orm/core";

export default class Connected extends Model {
    static entity = 'userConnected';

    static fields () {
        return {
            id: this.uid(),
            user_id: this.number(null).nullable(),
        }
    }
}
